import {trigger, transition, style, animate} from '@angular/animations';
import {Component, HostListener, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild, ViewEncapsulation, Renderer2, ElementRef} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatExpansionPanel} from '@angular/material/expansion';
import {MatSnackBar} from '@angular/material/snack-bar';
import { ApiService } from 'app/services/api.service';
import { SocketService } from 'app/services/socket.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe, ViewportScroller } from '@angular/common';
import { SwiperComponent, SwiperDirective, SwiperConfigInterface,
  SwiperScrollbarInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
import {DeviceDetectorService } from 'ngx-device-detector';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-passenger-digital-twin',
  templateUrl: './passenger-digital-twin.component.html',
  styleUrls: ['./passenger-digital-twin.component.css'],
})
export class PassengerDigitalTwinComponent implements OnInit {
  isPortrait: boolean;
  @ViewChild('expansionPanel', {static: false}) expansionPanel: MatExpansionPanel;
  activeIndex = 0;
  overAllStatus = {
    'left_camera': true,
    'right_camera': true
  };
  shoppingExpand: boolean = false;
  etaExpand: boolean = false;
  boarding_msg = 'Boarding Started';
  gate_close = 0;
  // recallBoardingFlight: any = null;
  adClose: boolean = false;
  checkRolling: any = 'assets/images/checkrollingss.gif';
  childData: any = {};
  @Output() revertBack: EventEmitter<any> = new EventEmitter();
  videSrc: string = '';
  expand: boolean = true;
  scanCount: number = 0;
  spinner = false;
  adTimer: any;
  adSrc = '';
  adCounter: number = 1;
  countdowncount: number = 11;
  pc: RTCPeerConnection | null = null;
  videoContainer: HTMLVideoElement | null = null;
  restartTimeout: any = null;
  sessionUrl: any = '';
  queuedCandidates: any = [];
  offerData: any = null;
  streamUrl = 'https://stream.adr.avileap.com/webrtc/main/1037070/';
  timer: any = {s: 72000, mn: 0, hr: 0};
  mintimer: any = {s: 72000, mn: 0, hr: 0};
  mintimerHandler: any;
  showclose: boolean = false;
  thankingMsgCondition: boolean = false;
  thankingTimeCondition: boolean = false;
  thankYouMsg: string = 'Thank You!';
  flightData;
  flightNo: string;
  dataarray;
  data=[];
  camcahneg:boolean = true;
  ratingspinner:boolean = false
  callapi;
  callapi1;
  imageFlightCode: boolean = true;
  clicked: number = 0;
  ref: MatDialogRef<any>;
  ratingarray;
  rating;
  norating:boolean = true;
  ratingsent:boolean = false;
  datamessage = '';
  ratingname:string = '';
  engdis: boolean = true;
  paxsessionid;
  device;
  source;
  medium;
  RatingComment:string = '';
  fromispotrait:boolean;
  verifyqr:boolean = false;
  iseng : boolean = true
  public config: SwiperConfigInterface = {
    slidesPerView: 'auto',
    keyboard: true,
    mousewheel: true,
    scrollbar: false,
    navigation: true,
    pagination: false
  };
  @ViewChild(SwiperComponent, { static: false }) componentRef?: SwiperComponent;
  public type: string = 'component';

  public disabled: boolean = false;
  slider:boolean = false
  slides = [1, 2];
  currentIndex = 0; 
  callwatchcount;
  direction: 'right' | 'left' ='right';
  Showalert:boolean = false;
  refreshvalue:boolean = false;
  langconfig;
  langcode;
  is_inpnrscreen:boolean = false;
  index='';
  indexr='';
  isStarted:boolean = false; 
  isExpanded:boolean = false;
  shownotifi:boolean = false;
  isCollapsing:boolean = false;
  showcontent:boolean = false;
  showbtext:boolean = false;
  collapsedivfunc;
  boadringmessage;
  boardingtime;
  imagesarray;
  isReviewVisible:boolean = false;
  review:any;
  delaytime;
  environment = environment;
  Imagesarray=[
    'assets/images/dummyimages.png',
    // 'assets/images/dummyimages2.png',
    // 'assets/images/dummyimages3.png'
  ]
  constructor(private apiService: ApiService,
    private socketservice: SocketService,
    public dialog: MatDialog,
    private renderer: Renderer2, 
    private el: ElementRef, 
    private viewportScroller: ViewportScroller, 
    private snackBar: MatSnackBar, 
    public router: Router,
    private route: ActivatedRoute, 
    private date: DatePipe,
    private devicedetails: DeviceDetectorService,
    private cookie: CookieService,
    ) {
    this.isPortrait = window.innerHeight > innerWidth ? true : false;
    this.data= [];
    this.route.queryParams.subscribe(params => {
      this.flightNo = params['gateno'].toUpperCase();
    });
    this.paxsessionid = this.route.snapshot.queryParams['pax-View_session'];
    this.paxsessionid = sessionStorage.getItem('sessionId') ? this.apiService.getsessionId('sessionId'): this.paxsessionid;
    this.checkOrientation();
  }


  public toggleSlidesPerView(): void {
    if (this.config.slidesPerView == 1) {
      this.config.slidesPerView = 1;
    } else {
      this.config.slidesPerView = 2;
    }
  }

  onIndexChange(event: any) {
    this.currentIndex = event;
  }


  public onSwiperEvent(event: string): void {
  }
  
  @HostListener ('window:focus', ['$event'])
  onFocus (event: any): void {
    this.isPortrait = window.innerHeight > window.innerWidth ? true : false
    this.startPlaying();
    // this.callingBoardingFlight();
    this.callwatchcount = setInterval(() => {
      this.sendwatchcount1();
    }, 30000);
  }

  @HostListener('window:blur', ['$event'])
    onBlur(event: any): void {
      clearInterval(this.callwatchcount);
    }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.checkOrientation();
    this.sendwatchcount();
    this.fromispotrait = true;
    this.paxsessionid = sessionStorage.getItem('sessionId') ? this.apiService.getsessionId('sessionId'): this.paxsessionid;
  }

  onSwipe(evt){
    const x = Math.abs(evt.deltaX) > 40 ? (evt.deltaX > 0 ? this.iseng = true : this.iseng = false) : '';
  }

  ngOnInit() {
    this.is_inpnrscreen = true;
    this.isPortrait = window.innerHeight > window.innerWidth ? true : false
    this.paxsessionid = sessionStorage.getItem('sessionId') ? this.apiService.getsessionId('sessionId'): this.paxsessionid;
    this.childData = JSON.parse(JSON.stringify(this.childData));
    const devicedetails = this.devicedetails.getDeviceInfo();
    const deviceres = window.innerHeight + '*' + window.innerWidth;
    const devicetype = this.devicedetails.isTablet() ? 'Tablet' : this.devicedetails.isMobile() ? 'Mobile' : this.devicedetails.isDesktop() ? 'Desktop' : 'Others';
    if(this.route.snapshot.queryParams['pax_view_session']){
      this.paxsessionid = this.route.snapshot.queryParams['pax_view_session'];
    }
      this.device = devicetype;
      sessionStorage.setItem('fromdevice',this.device);
    if(this.route.snapshot.queryParams['source']){
      this.source = 'bahome';
      // this.source = this.route.snapshot.queryParams['source'];
      sessionStorage.setItem('fromsource',this.source);
      sessionStorage.setItem('source', this.source);
    }else {
      this.source = 'bahome';
      // this.source = this.route.snapshot.queryParams['source'];
      sessionStorage.setItem('fromsource',this.source);
      sessionStorage.setItem('source', this.source);
    }
    if(this.route.snapshot.queryParams['medium']){
      this.medium = this.route.snapshot.queryParams['medium'];
      sessionStorage.setItem('medium',this.medium);
    }else if(sessionStorage.getItem('medium')){
      this.medium = sessionStorage.getItem('medium');
    }else{
      this.medium = 'weblink'
      sessionStorage.setItem('medium',this.medium);
    }
    if(this.paxsessionid){
      const param = {
        pax_session_id: this.paxsessionid,
        browser_name : devicedetails.browser,
        browser_version: devicedetails.browser_version,
        device_name: devicedetails.device,
        os_name: devicedetails.os,
        os_version: devicedetails.os_version,
        device_type: devicetype,
        user_agent: devicedetails.userAgent,
        resolution: deviceres
      }
      if (window.performance.navigation.type === 1) {
        param['refresh'] = true;
      }
      this.apiService.verifyapi(param).subscribe(response=>{
        if(response){
          this.verifyqr = true;
          this.data = this.apiService.getSharedData();
          if(!this.data){
            this.calldata()
          }
          else if(this.data){
            this.thankingMsgCondition = false;
            this.dataarray = this.data[0];
            this.callapiwithlanguage()
          }
          this.sendwatchcount();
          this.callwatchcount = setInterval(() => {
            this.sendwatchcount1();
          }, 30000);
        }
      },(error)=>{
        this.router.navigate(['']);
        history.pushState(null, '','/');
        this.apiService.verifyapifailed.next(true)
      })
    }else if(!this.paxsessionid){
      const param = {
        browser_name : devicedetails.browser,
        browser_version: devicedetails.browser_version,
        device_name: devicedetails.device,
        os_name: devicedetails.os,
        os_version: devicedetails.os_version,
        user_agent: devicedetails.userAgent,
        resolution: deviceres,
        device_type: devicetype,
        gate: this.flightNo,
        device: this.device ? this.device : 'Undefined',
        source: this.source ? this.source : 'Undefined',
        medium: this.medium ? this.medium : 'Undefined',
      }
      this.apiService.getsession(param).subscribe(res=>{
        this.apiService.setsessionId('sessionId', res.id, 2);
        this.paxsessionid = res.id;
        const param = {
          pax_session_id: res.id,
          browser_name : devicedetails.browser,
          browser_version: devicedetails.browser_version,
          device_name: devicedetails.device,
          os_name: devicedetails.os,
          os_version: devicedetails.os_version,
          user_agent: devicedetails.userAgent,
          device_type: devicetype,
          resolution: deviceres
        }
        this.apiService.verifyapi(param).subscribe(res=>{
          this.verifyqr = true;
          this.data = this.apiService.getSharedData();
        if(!this.data){
          this.calldata()
        }else if(this.data){
            this.thankingMsgCondition = false;
            this.dataarray = this.data[0];
            this.callapiwithlanguage();
          }
          this.sendwatchcount();
          this.callwatchcount = setInterval(() => {
            this.sendwatchcount1();
          }, 30000);  
      },(error)=>{
        this.router.navigate(['']);
        history.pushState(null, '', '/');
        this.apiService.verifyapifailed.next(true)
      })    
    })
    }
    // this.callapi = setInterval(() => {
    //   this.callingBoardingFlight()
    // }, 30000);
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
    if (this.adTimer) {
      clearInterval(this.adTimer);
    }
    this.etaExpand = false;
    this.boarding_msg = 'Boarding Started';
    this.gate_close = 0;
    this.adClose = false;
    this.spinner = false;
    this.adTimer;
    this.adSrc = '';
    this.adCounter = 1;
    this.countdowncount = 11;
    this.thanksImg = false;
    this.boardingStatus = false;
    this.countdownTimer = null;
    this.changeColor();
    // }
    this.checkrating();
  }



  callapiwithlanguage(){
    this.apiService.language.subscribe((res)=>{
      this.langcode = res.code
      this.langconfig = this.langcode == 'En' ? require("../../Language/En-us.json") : require("../../Language/It-us.json")
      this.ratingarray = this.langconfig.ratingarray
      if(this.is_inpnrscreen){
          const gatelist = [];
          gatelist.push(this.flightNo)
          const langcode = this.langcode.toLowerCase();
          this.socketservice.callgatedata(gatelist, langcode);
          sessionStorage.setItem('gate', this.flightNo);
          sessionStorage.setItem('langcode', langcode);
          this.callsocketdata();
        this.callingBoardingFlight();
        // this.onStarClick(this.index, this.indexr);
      }else {
        return;
      }
      })
  }

  disclaimerclick(event){
    this.currentIndex = event;
    this.engdis = !this.engdis
  }

  onStarClick(index, indexr, s?) {
    this.index = index;
    this.indexr = indexr;
    this.norating = false
    if(s){
      this.isReviewVisible = true
    }
    if(!this.norating){
      this.clicked = index;
      this.rating = index;
      this.ratingname = this.langconfig.ratingarray[indexr];
    }
  }

  setflightstatus(status) {
    if (status) {
      if(status.includes(',')){
        const statustextArray = status.split(',');
        const firstText = statustextArray[0];
        const secondText = statustextArray[1];
        return `${firstText} <br> ${secondText}`;
      } else {
          return status;
      }
    } else {
      return '-';
    }
  }  

  sendrating(){
    if(this.rating && this.RatingComment.length >3){
      this.ratingspinner = true;
      const param ={
        rating: this.rating,
        pax_session_id: this.paxsessionid,
        comments: this.RatingComment
      }
      this.apiService.sendrating(param).subscribe(res=>{
        this.ratingsent = true;
        sessionStorage.setItem('rating', this.rating);
        this.ratingspinner = false;
      },(error)=>{
        this.ratingspinner = false
      })
    }
  }


  cancelrating(){
    this.RatingComment = '';
    // this.rating = 0;
    this.norating = true;
    this.isReviewVisible = false;
    this.clicked = 0;
  }

  sendwatchcount(){
    if(this.paxsessionid){
      if (window.performance.navigation.type === 1) {
        this.refreshvalue = true;
      }
      const params ={
        pax_session_id :this.paxsessionid,
        view: !this.isPortrait ? 'Landscape' : 'Portrait',
        user_refresh: this.refreshvalue
      }
      this.apiService.watchcountapi(params).subscribe((res)=>{
        this.refreshvalue = false;
      })
    }
  }

  sendwatchcount1(){
    if(this.paxsessionid){
      const params ={
        pax_session_id :this.paxsessionid,
        view: !this.isPortrait ? 'Landscape' : 'Portrait',
      }
      this.socketservice.sentwatchcount(params);
    }
  }

  checkOrientation(): void {
    this.isPortrait = window.innerHeight > window.innerWidth ? true : false
    // const newIsPortrait = window.innerHeight > window.innerWidth;
    // if (newIsPortrait !== this.isPortrait) {
    //   this.isPortrait = newIsPortrait;
    //   // this.showOrientationPopup();
    // }
    // if(this.isPortrait){
      //  this.calldata();
    // }
  }

  calldata(){
      this.apiService.gates_api(this.flightNo).subscribe(response => {
        this.apiService.setSharedData(response.data);
        this.data = this.apiService.getSharedData();
        this.thankingMsgCondition = false;
          this.dataarray = this.data[0];
          this.callapiwithlanguage();
      })
  }

  closedialog(){
    this.ref.close();
  }

  admertisementclick(link?){
    if(link){
      this.langconfig = this.langcode == 'En' ? require("../../Language/En-us.json") : require("../../Language/It-us.json")
      const advertaisement_link = this.langconfig ? this.langconfig.advertaisementlink : ''
      window.open(
       advertaisement_link,
       "_blank",
     );
    }
}
Imagegif;
Imagesource(){
  if(this.childData.status){
    if(this.childData.boarding_percentage >= 90 || (this.childData.status ==  'BOARDING MAY BE CLOSING'|| this.childData.status == "L'IMBARCO POTREBBE ESSERE IN CHIUSURA")){
      return 'assets/images/bmore90.gif';
    }else if((this.childData.status == 'NO FLIGHT ASSIGNED TO THIS GATE'|| this.childData.status == "NESSUN VOLO ASSEGNATO A QUESTA GATE") || (this.childData.status ==  "NO INFORMATION AVAILABLE, PLEASE PROCEED TO YOUR GATE"|| this.childData.status == 'NESSUNA INFORMAZIONE DISPONIBILE, PROCEDERE AL VOSTRO GATE')){
      return 'assets/images/nof.gif'
    }else if(this.childData.boarding_percentage < 90 && this.childData.boarding_percentage){
      return 'assets/images/bless90.gif'
    }else if(!this.childData.boarding_percentage){
      return 'assets/images/nob.gif'
    }
  }
};
  startPlaying() {
    if (!this.thankingMsgCondition && this.dataarray && this.dataarray.front_camera) {
      const embeddedPlayer = document.getElementById("embedded-player") as HTMLIFrameElement;
      if(embeddedPlayer){
        embeddedPlayer.src = this.dataarray.front_camera;
        function toggleFullScreen() {
          if (!document.fullscreenElement) {
            if (embeddedPlayer.requestFullscreen) {
              embeddedPlayer.requestFullscreen().catch(err => {
                console.error(`Error attempting to enable full-screen mode: ${err.message}`);
              });
            }
          } else {
            if (document.exitFullscreen) {
              document.exitFullscreen();
            }
          }
          embeddedPlayer.addEventListener("click", toggleFullScreen);
          embeddedPlayer.style.width = "100%";
          embeddedPlayer.style.height = "56.25vw";
        }
      }
    }
  }

  currentCameraIndex: number = 0;
  camclicked() {
    if(!this.thankingMsgCondition && this.dataarray.left_camera || !this.thankingMsgCondition && this.dataarray.right_camera){
    const cameraUrls: string[] = [this.dataarray.front_camera];
    if (this.dataarray.left_camera) {
      cameraUrls.push(this.dataarray.left_camera);
    }
    if (this.dataarray.right_camera) {
      cameraUrls.push(this.dataarray.right_camera);
    }
    const embeddedPlayer = document.getElementById("embedded-player") as HTMLIFrameElement;
    if (embeddedPlayer) {
      this.currentCameraIndex = (this.currentCameraIndex + 1) % cameraUrls.length;
      embeddedPlayer.src = cameraUrls[this.currentCameraIndex];
      function toggleFullScreen() {
        if (!document.fullscreenElement) {
          if (embeddedPlayer.requestFullscreen) {
            embeddedPlayer.requestFullscreen().catch(err => {
              console.error(`Error attempting to enable full-screen mode: ${err.message}`);
            });
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          }
        }
      }
  
      embeddedPlayer.addEventListener("click", toggleFullScreen);
  
      embeddedPlayer.style.width = "100%";
      embeddedPlayer.style.height = "56.25vw";
    } 
  }
  }  

  callingBoardingFlight() {
    if ((this.dataarray && this.dataarray.gate_no)) {
      const params = {
        gate: this.dataarray && this.dataarray.gate_no ? this.dataarray.gate_no : this.flightNo,
        // language: this.langcode
      }
      const langcode = this.langcode == 'En' ? 'en-US' : 'it-IT';
      this.apiService.adrInnerVideo(params, langcode).subscribe((res: any) => {
        if (res.data) {
          this.childData = {};
          this.childData = {...this.childData, ...res.data} || {};
          const logid = this.childData.logid;
          sessionStorage.setItem('flight_logid', logid);
          if(localStorage.getItem('subvalue')){
            this.apiService.callsavesubscription('updatevalue');
          }
          if(this.childData.boarding_pts){
            this.boardingtime = new Date(this.childData.boarding_pts);
          }
          // if(this.childData.flight_code == 'BA'){
          //   sessionStorage.setItem('bahome', 'true');
          //   this.apiService.isbaflight.next(true);
          // }
          if(this.childData.message){
            this.boadringmessage = this.childData.message;
            if(this.boadringmessage.msg){
              this.animateDiv();
            }else if(!this.boadringmessage){
              this.shownotifi = false;
            }
          }
          sessionStorage.setItem('logid', this.childData.logid);
          this.socketservice.callnotofication(this.childData.logid)
          this.startPlaying();
          this.showclose = (this.childData.status == 'Boarding will start soon ' || this.childData.status == 'Gate not assigned to any flight ')? true : false;
          this.revertTimer(!this.childData.flightnodep,this.boardingtime);
          this.Showalert = this.childData.alert
          this.paxsessionid = this.apiService.getsessionId('sessionId');
          !this.paxsessionid ? this.apiService.verifyapifailed.next(true): '';
          !this.paxsessionid ? this.router.navigate(['']): '';
        }
      });
    }
  }

  callsocketdata(){
    this.apiService.digitaltwingateData.subscribe((res)=>{
      if(res){
        const responce = res['msg']
        delete responce['publisher']
        const key = Object.keys(responce);
        const value = Object.values(responce);
        if(this.flightNo == key[0]){
          this.childData = value[0]
          const loggedid = sessionStorage.getItem('flight_logid')
          if(this.childData.logid != loggedid){
            sessionStorage.setItem('flight_logid', this.childData.logid);
            if(localStorage.getItem('subvalue')){
              this.apiService.callsavesubscription();
            }
          }
          if((this.childData.flight_code && this.childData.flight_code != 'BA') || !this.childData.flight_code){
            this.router.navigate(['']);
            history.pushState(null, '','/');
          }
        }
      }
    })
    this.apiService.callnotification.subscribe((res)=>{
      if(res){
        const responce = res['msg']
        delete responce['publisher']
        const key = Object.keys(responce);
        const value = Object.values(responce);
        if(value[0]){
          if(value[0]['msg']){
            this.boadringmessage = value[0];
          }else{
            this.boadringmessage = {
              msg:'',
              group:'',
              stage:''
            }
          }
          if(this.boadringmessage.msg && !this.isExpanded){
            this.animateDiv();
          } else if(!this.boadringmessage.msg && this.isExpanded){
            return;
          } else if(!this.boadringmessage.msg){
            this.collapseDiv();
            this.shownotifi = false;
          }
        }
      }
    })
  }

  animateDiv() {
    if (this.isExpanded || this.isStarted) {
      this.collapseDiv();
    } else {
      this.startExpandAnimation();
    }
  }

  collapseDiv() {
    if(this.collapsedivfunc){
      clearTimeout(this.collapsedivfunc)
    }
    this.isCollapsing = true;
    this.showtext = false;
    if(!this.isStarted && !this.isExpanded){
      setTimeout(() => {
        this.isCollapsing = false;
        this.startExpandAnimation();
      }, 2000);
    }
    this.isStarted = false;
    this.isExpanded = false;
  }

  showtext:boolean = false;
  startExpandAnimation(clicked?) {
    if(!clicked){
      this.isStarted = true;
      setTimeout(() => {
        this.showcontent = true
      }, 300);
      setTimeout(() => {
        setTimeout(() => {
          this.showbtext = true
        }, 300);
        setTimeout(() => {
          this.showtext = true;
        }, 400);
        this.isExpanded = true;
        this.shownotifi = true;
       this.collapsedivfunc = setTimeout(() => {
          this.collapseDiv()
        }, 5000);
      }, 5000);
    }else{
      this.isExpanded = true;
      this.shownotifi = true;
      setTimeout(() => {
        this.showtext = true;
      }, 500);
       this.collapsedivfunc = setTimeout(() => {
          this.collapseDiv()
        }, 5000);
    }
  }

  shownotification(){
    this.startExpandAnimation('clicked')
  }

  navigatetorating(){
    const element = document.getElementById('targetDiv');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  navigateclick(){
    this.router.navigate(['/app/digital-twin'])
  }

  getLogoImage() {
    return this.childData.flight_code ? `assets/images/airlineLogos/${this.childData.flight_code}.png` : null;
  }

  onLoadFlightError(event: any) {
    this.imageFlightCode = false;
  }

  numberDigits(n: number) {
    return n > 9 ? '' + n : '0' + n;
  }

  revertTimer(data: boolean, btime: any = null) {
    if (data && btime) {
      setInterval(() => {
        this.timer.s -= 1;
        this.getDiffrence(btime);
        // if (this.timer.s < 0) {
        //   // this.timer.s = 59;
        //   // this.timer.mn = -1;
        //   this.onBack();
        // }
      }, 1000);
    }

    // this.mintimerHandler = setInterval(() => {
    //   this.mintimer.s -= 1;
    //   if (this.mintimer.s == 20) {
    //     this.thankingTimeCondition = true;
    //   }
    //   if (this.mintimer.s < 0) {
    //     // this.timer.s = 59;
    //     // this.timer.mn = -1;
    //     this.thankingTimeCondition = false;
    //     this.thankingMsgCondition = true;
    //     const aaa = document.getElementById('embedded-player') as HTMLIFrameElement;
    //     aaa.src = '';
    //     clearInterval(this.mintimerHandler);
    //   }
    // }, 1800);
  }

  getDiffrence(btime) {
    let dateNow: any = new Date(new Date().toLocaleString('en-US', {timeZone: '+0100'}))
    let dateFuture: any = new Date(btime.getFullYear() +1, 0, 1);

    let seconds = Math.floor((dateFuture - (dateNow))/1000);
    let minutes = Math.floor(seconds/60);
    let hours = Math.floor(minutes/60);
    let days = Math.floor(hours/24);

    hours = hours-(days*24);
    minutes = minutes-(days*24*60)-(hours*60);
    seconds = seconds-(days*24*60*60)-(hours*60*60)-(minutes*60);
    this.timer = {s: seconds, mn: minutes, hr: hours};
  }

  openSnackBar(message: string, action?: string) {
    this.snackBar.open(message, action, {
      panelClass: ['snackbar-background'],
      duration: 2000,
    });
  }

  changeColor() {
    this.childData.video_url = this.childData.video_url === this.childData.left_camera ? this.childData.right_camera : this.childData.left_camera;
  }

  getCardStyles(index: number) {
    return {
      'background-color': this.activeIndex === index ? '#3BB9B9' : 'darkgray'
    };
  }

  boardingStatus: boolean = false;

  countdownTimer: any;
  thanksImg: boolean = false;

  showThankyouSlide() {
    this.thanksImg = true;
  }

  getadvertaisement(data){
    if(data['show_advertisement'] && this.langcode == 'En'){
      return 'assets/images/AITCENG.jpg';
    }else if(data['show_advertisement'] && this.langcode != 'En'){
      return 'assets/images/AITCITA.jpg';
    }
    //  src="assets/images/advertisement.jpg"
  }

  ngOnDestroy() {
    this.is_inpnrscreen = false;
    if (this.adTimer) {
      clearInterval(this.adTimer);
    }
      clearInterval(this.callapi);
    clearInterval(this.callapi1);
    clearInterval(this.callwatchcount);
    sessionStorage.removeItem('sessionId');
    sessionStorage.removeItem('gate');
    // sessionStorage.removeItem('rating')
    sessionStorage.removeItem('fromdevice');
    sessionStorage.removeItem('fromsource');
    sessionStorage.removeItem('medium');
  }

  renderPreBoarding() {
    this.boardingStatus = true;

    setTimeout(() => {
      this.changeColor();
    }, 15000);
  }

  checkrating(){
    this.ratingsent =sessionStorage.getItem('rating') ? true : false
  }

  refresh() {
    this.camcahneg = !this.camcahneg;
    this.timer = {s: 72000, mn: 0, hr: 0};
    this.mintimer = {s: 72000, mn: 0, hr: 0};
    this.callingBoardingFlight();
    this.startPlaying();
  }

  redtext:boolean = false;
  checkvalue(flight){
    if(flight){
      const std = this.date.transform(flight.std);
      const etd = this.date.transform(flight.etd);
      this.redtext = std == etd ? false : true;
      return std == etd ? false : true;
    }
  }

  onBack() {
    this.router.navigate(['/']);
  }
}